import { ProductChildcaresLine } from 'Components/lines/product-childcares-line/ProductChildcaresLine';
export default ProductChildcaresLine;
